import React, { useState, useEffect } from "react";
import ImageUploadPopup from "../Popup/ImageUploadPopup";
import { NavLink } from "react-router-dom";
import Language from "../Card/Lang";
import { textMapping } from "../utils/helper";
const CryptoJS = require("crypto-js");

const UserProfile = ({ getProfile, editphoto }) => {
  const [langSelect, setLangSelect] = useState("en");
  const [profile, setProfile] = useState("");
  const [imageval, setImageval] = useState(false);

  const decryptData = (encryptedData, secretKey) => {
    try {
      if (!encryptedData) return null;
      const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      return decryptedData ? JSON.parse(decryptedData) : null;
    } catch (error) {
      console.error("Error during decryption or parsing:", error);
      return null;
    }
  };
  useEffect(() => {
    // const secretKey = "2ca6f23d8cc3e1e1";
    // const encryptedData = localStorage.getItem("user");
    // const decryptedData = decryptData(encryptedData, secretKey);
    // if (decryptedData) {
    //   setProfile(decryptedData["avatar"]);
    //   localStorage.setItem("profile", decryptedData["avatar"]);
    // }
    if (editphoto) {
      setProfile(editphoto);
    }

    const savedLang = localStorage.getItem("language");
    if (savedLang) {
      setLangSelect(savedLang);
    } else {
      localStorage.setItem("language", langSelect);
    }
  }, [langSelect, editphoto]);

  const handleImage = () => {
    setImageval(true);
  };

  const ImagePopupClose = () => {
    setImageval(false);
  };

  const UploadHanlde = (imageURL) => {
    setProfile(imageURL);
    getProfile(imageURL);
    // localStorage.setItem("profile", imageURL);
    ImagePopupClose();
  };
  return (
    <>
      <div className="member_container">
        <div className="filldetail_flex">
          {/* <NavLink
            to={"/otp" + window.location.search}
            className="backarrow_link"
          >
            <img
              src="/assets/images/backarrow.svg"
              className="arrowback"
              alt=""
            />
          </NavLink> */}
          <h5>{textMapping("Provide Details")}</h5>
          {/* <div className="langselecttop_pos">
            <Language />
          </div> */}
        </div>
        <div className="user_profile_main">
          <div className="user_profile_div" onClick={handleImage}>
            <img
              src={profile ? profile : "/assets/images/userdefault.jpg"}
              className="user_img"
              alt=""
            />
            {/* <input type="file" /> */}
            <button className="upload_btn" onClick={handleImage}>
              <img src="/assets/images/uploadedit.svg" alt="" />
            </button>
          </div>

          <h4 className="user_name">{textMapping("Upload")}</h4>
        </div>
      </div>
      {imageval && (
        <ImageUploadPopup
          ImagePopupClose={ImagePopupClose}
          UploadHanlde={UploadHanlde}
        />
      )}
    </>
  );
};
export default UserProfile;
